<div class="" style="background-color: #b3ccff; height:100%;">
  
  <div class="card-body">
    <div class="row" class="text-center">
      <div class="institutelogohead">
        <img src="./assets/img/board_logo.png" class="loginlogo mx-auto">
        <h1 class="title h1" id="title">GOA BOARD OF SECONDARY AND HIGHER SECONDARY EDUCATION</h1>
      </div>
      <h1 class="title1 h1">Online Document Issuance Portal</h1>
       </div>
    <!-- <div class="row">
      <div class="col-xl-6"></div>
      <div class="col-xl-6">
        <a href=""><h5>
        <u style="float:right;cursor: pointer;font-size: 40px;"><i class="bi bi-house-fill" style="color:black;"></i></u>
      </h5></a></div></div> -->
      <div class="row pt-1">
        <div class="col-xl-6 my-2" style="border-right: groove #c3e9ff 0.2rem;">
          <div class="row">
            <div class="col-xl-2"></div>
            <div class="col-xl-10" style="text-align: center;">
              <!-- <h1 class="title" id="title">Online Document Issuance Portal</h1> -->
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-xl-2"></div>
            <div class="col-xl-10" style="text-align: center;">
              <h4 class="h4">Sign in</h4>
            <!-- <h4>Online Document Issuance Portal ! </h4> -->
            </div>
          </div>
            <!-- <div class="row">
              <div class="col-xl-3"></div>
            </div>
            <div class="row">
              <div class="col-xl-3"></div>
              <div class="col-xl-8"></div>
            </div>
            <div class="row">
              <div class="col-xl-3"></div>
              <div class="col-xl-8"></div>
            </div> -->
           <form  method="post" role="form" name="form1" #form="ngForm" [formGroup]="Loginform" (ngSubmit)="onSubmit(Loginform.value)">
                <div class="row">
                  <div class="col-xl-3"> </div>
    <div class="col-xl-8">
  <div class="form-group">
    <label class="label" for="input-user">Username</label>
    <input (keydown)="hidewarningmsg()" type="text" formControlName="username" name="username" id="username" class="form-control  border-left-0" style="padding: 12px;"
    [ngClass]="{ 'is-invalid': submitted && f.username.errors }" placeholder="Enter your username"/>
  <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
    <div *ngIf="f.username.errors.required">Please enter your UserName</div>
  </div>
  </div>
</div>
</div>
<div class="row">
  <div class="col-xl-3">
  </div>
  <div class="col-xl-8">
    <div class="form-group"><label class="label" for="input-password">Password</label>
      <input (keydown)="hidewarningmsg()" [type]="typetext1 ? 'text' : 'password'" formControlName="password" name="password" id="password"style="padding: 12px;" class="form-control  border-left-0"
          [ngClass]="{ 'is-invalid': submitted && f.password.errors }" placeholder="Enter your password"/>
          <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
            <div *ngIf="f.password.errors.required">Please Provide Password</div>
          </div>
  </div></div></div>
  <div class="row pt-1">
    <div class="col-xl-3"></div>
    <div class="col-xl-8">
    <div class="form-control-group accept-group">
    <a class="forgot-password" (click)="gotoresetpassword()"> Forgot Password?</a>
    </div>
    </div>
    </div>


    <div class="row">
          <div class="col-xl-3">
          </div>
          <div class="col-xl-8">
          <ngx-recaptcha2 #captchaElem
          [siteKey]="siteKey" [ngClass]="{ 'is-invalid': submitted && f.recaptcha.errors }"
          formControlName="recaptcha">
          </ngx-recaptcha2>
          <div *ngIf="submitted && f.recaptcha.errors" class="invalid-feedback">
          <div *ngIf="f.recaptcha.errors.required">Recaptcha is required</div>
          </div>
          </div>
    </div>
    

      <div class="row"><div class="col-xl-3"></div><div class="col-xl-8">
        <button  class=" btn btn-success btn-full-width mt-4" type="submit"> Login</button>
      </div></div></form>
    </div>
    <div class="col-xl-6 my-2">
      <div class="row mt-2">
        <div class="col-xl-2">
        </div>
        <div class="col-md-10">
            <h4 class="h4">Apply For : </h4>
            <ul class="">
              <li class="list-group-item">Fresh Migration Certificate</li>
              <li class="list-group-item">Duplicate Passing Certificate</li>
              <li class="list-group-item">Duplicate Marksheet</li>
              <li class="list-group-item">Change Request On Marksheet</li>
              <li class="list-group-item">Change Request On Passing Certificate</li>
            </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-1">
        </div>
        <div class="col-xl-8">
          <section aria-label="Register" class="another-action">
            <h4 class="title">Don't have an account?</h4>
          </section>
        </div>
      </div>
      <div class="row">
            <div class="col-xl-1"></div>
            <div class="col-xl-8" style="text-align: center;margin-top: -1rem;">
              <i style="font-size: 3.5rem;" class="bi bi-people-fill"></i>
            </div>
      </div>
     
      <div class="row">
          <div class="col-md-12">

          </div>
      </div>
      <div class="row mb-3">
        <div class="col-xl-2"></div>
          <div class="col-xl-6">
            <button  class="btn btn-primary btn-full-width" [routerLink]="['/register']">Register</button>
          </div>
      </div>
      <div class="row mb-3">

      </div>
      </div>
    </div>
      </div>
      <div *ngIf="proccessing" class="loadingcont">
        <div class="spinner"></div>
      </div>
</div>
<!---modal-->
<!-- <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header text-center">
        <h5 class="modal-title" id="exampleModalLabel">Candidate</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <form method="post" role="form" >
      <div class="modal-body">
        <div class="row mb-3">
              <label for="inputPassword3" class=" col-form-label">Username<span>*</span></label>
              <div class="">
                <input type="text" class="form-control" value="" placeholder="Username">
              </div>
           </div>
           <div class="row mb-3">
              <label for="inputPassword3" class="col-form-label">Email<span>*</span></label>
              <div class="">
                <input type="text" class="form-control" id="inputPassword3" placeholder="Email">
              </div>
            </div>
            <div class="row mb-3">
              <label for="inputPassword3" class="col-form-label">Password<span>*</span></label>
              <div class="">
                <input type="password" class="form-control" id="inputPassword3" value="" placeholder="Password">
              </div>
            </div>
            <div class="row mb-3">
              <label for="inputPassword3" class="col-form-label">Password<span>*</span></label>
              <div class="">
                <input type="password" class="form-control" id="inputPassword3" value="" placeholder="RePassword">
              </div>
            </div>
          </div>
      <div class="modal-footer">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end" >
          <button class="btn btn-danger me-md-2" type="button" data-bs-dismiss="modal" (click)="openPopup()">Register</button>
          <!-- <button class="btn btn-success me-md-2" type="button">Save Changes</button>
        </div>
      </div>
      </form>
    </div>
</div>
</div>
<div
class="modal pt-5"
tabindex="-1"
role="dialog"
[ngStyle]="{'display':displayStyle}">
<div class="modal-dialog" role="document" style="max-width:340px!important;">
  <div class="modal-content">
    <div class="text-end">
        <button type="button" class="btn-close"  (click)="closePopup()" aria-label="Close"></button>
        </div>
    <div class="modal-body p-3">
      <form class="form-login">
        <div class="form-group">
            <input type="text" class="form-control"
                name="otp" id="OTP"
                aria-describedby="emailHelp"
                placeholder="Enter OTP" required>
        </div>
        <div class="row">
          <div class="col-md-6">
        <button type="button"
            class="btn btn-primary btn-lg"
            id="verify-otp">
            Verify OTP
        </button>
        </div>
        <div class="col-md-6">
        <button type="button"
            class="btn btn-warning btn-lg"
            id="verify-otp">
            Resend OTP
        </button>
        </div>
        </div>
    </form>
  </div>
</div>
</div>
</div> -->


